import React from 'react';
import '../css/Instagram.css';

// Imagen
import instagran01 from '../img/Instagram/campaña-solidaria.jpg';

// Icono
import instagram from '../img/logos/instagram-icon.png';

class InstagramGallery extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            photos: [

                {
                    url: 'https://www.instagram.com/p/DbGYkurxd6j/',
                    imageUrl: instagran01,
                },

            ],

        };

    }

    handleIconClick = (icon) => {
        console.log(`Click en ${icon}`);
    };

    render() {

        const { photos } = this.state;

        return (

            <section
                id="Instagram-list"
                className="esc-instagram-gallery"
            >

                {/*==============================
                    TITULO
                ==============================*/}

                <div className="esc-instagram-header">

                    <h2 className="esc-section-title">
                        Galería Instagram
                    </h2>

                    <div className="esc-title-divider">
                        <span className="esc-red"></span>
                        <span className="esc-blue"></span>
                    </div>

                    <p className="esc-section-subtitle">
                        Conoce nuestras publicaciones y actividades
                        compartidas en Instagram.
                    </p>

                </div>

                {/*==============================
                    TARJETAS
                ==============================*/}

                <div className="esc-instagram-container">

                    {photos.map((photo, index) => (

                        <div
                            key={index}
                            className="esc-instagram-card"
                        >

                            <div
                                className="esc-instagram-image"
                                style={{
                                    backgroundImage: `url(${photo.imageUrl})`
                                }}
                            />

                            <a
                                href={photo.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="esc-instagram-button"
                                onClick={() => this.handleIconClick('instagram')}
                            >

                                <img
                                    src={instagram}
                                    alt="Instagram"
                                    className="esc-instagram-icon"
                                />

                                Ver publicación

                            </a>

                        </div>

                    ))}

                </div>

            </section>

        );

    }

}

export default InstagramGallery;